<template>
    <div>
       <div class="has-text-right posRelative">
            <input class="input searchTextInput" type="text" placeholder="search profiles" v-model="terms"  @keyup.enter="doSearch"/>
            <button class="button is-coolGreen is-small left-10 has-text-grey" style="z-index: 1" @click="doSearch"><i class="fa fa-search"></i></button>
            <div v-show="show" id="profMenu" class="has-text-left">
                <div class="profileResultItem" v-for="(item, i) in results" :key="i" @click="showProfile(item)"><img class="tinyProfileImg"  :src="item.avatarImg && item.avatarImg.substring(0,5) == 'https' ? item.avatarImg : ''" /> {{item.handle}}</div>
                <div class="top10 handCursor" @click="showMore($event)">show more</div>
            </div>
           
       </div>

        
    </div>
</template>

<script>


import { AZEventBus } from '../components/AZEventBus'

export default{
    
    name: 'searchprofiles',
    data: function(){
        return {
            terms: '',
            show: false,
            results: [],
            offset: 0,
        }
    },

    mounted: function(){
        AZEventBus.$on('closeAllMenus', this.closeAllMenusHandler)
    },

    beforeDestroy: function(){
        AZEventBus.$off('closeAllMenus', this.closeAllMenusHandler)
    },

    methods: {

        closeAllMenusHandler: function(msg){
            this.show = false
            this.results = []   
            this.offset = 0
        },

        doSearch: function(){

            var self = this;

            function w(d){
                self.results = self.results.concat(d.results)
                self.show = true
                var el = document.getElementById('profMenu')
                setTimeout(function(){
                    el.scrollTo({left: 0, top:1000, behavior: 'smooth'});
                }, 1)
                
            }

            function n(){

            }

            this.$root.app.apiClient.post('open/confirm/profilesearch', {terms: this.terms, offset: this.offset, limit: 10}, w, n)
        },

        showProfile: function(item){
            this.$parent.$router.push({name: 'profiledelegate', params: {propProfile: item.handle}})
        },

        showMore: function(e){
            e.stopPropagation()
            this.offset += 10
            this.doSearch()
        }

    }

}

</script>

